// home — en. Part of the en i18n bundle; merged by ./index.js

export default {
  mpTopDashboard: 'Dashboard',
  mpTopRegister: 'Register',
  mpSearchCategory: 'Category',
  mpSearchAllCategories: 'All Categories',
  mpSearchLocation: 'Location',
  mpSearchAllCities: 'All Cities',
  mpSearchKeyword: 'What are you looking for?',
  mpSearchBtn: 'Search',
  mpTapToRead: 'Tap to read ▼',
  mpProducts: 'products',
};
